import { Eye } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface ViewDetailsButtonProps {
  onClick: (e: React.MouseEvent) => void;
  label?: string;
}

export function ViewDetailsButton({ onClick, label = 'View details' }: ViewDetailsButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="p-2 text-gray-700 hover:bg-gray-100 rounded transition-colors cursor-pointer"
            onClick={e => { e.stopPropagation(); onClick(e); }}
            type="button"
          >
            <Eye className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
